import { useRef } from "react";
import { fbAttachment, uploadImage } from "../../../../../../../services/upload/Upload";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../../../../../../store/action/loadingAction";
import { setError } from "../../../../../../../store/action/errorAction";
import { generateUUID, getTemporaryBlockId, processDeleteCard, processChangeCard } from "../../../../../../../services/helpers/Helper";
import Action from "./action";

const Image = (props) => {
   const { onChange, faqId } = props;
   let { card, data } = props;
   const ref = useRef();
   const dispatch = useDispatch();

   const handleClickUpload = () => {
      ref.current.click();
   }

   const onChangeFile = (e) => {
      const file = e.target.files[0];
      if (file) {
         dispatch(showLoading());
         uploadImage(file).then((response) => {
            if (onChange) {
               data = processChangeCard(data, {
                  ...card,
                  image: {
                     ...card.image,
                     image_url: response.data
                  }
               }, faqId);
               onChange(data);
               fbAttachment(response.data).catch((error) => {
                  dispatch(setError(error.message));
               });
            }
         }).catch((error) => {
            dispatch(setError(error.message));
         }).finally(() => {
            dispatch(hideLoading());
         });
      }
   }

   const getImage = () => {
      return card?.image?.image_url
   }

   const handleDelete = () => {
      if (onChange) {
         data = processDeleteCard(data, card, faqId);
         onChange(data);
      }
   }

   const handleCopy = () => {
      if (onChange) {
         card = {
            temporary_block_id: generateUUID(),
            type: card.type,
            title: card.title,
            image: {
               action_type: card.image.action_type,
               image_url: card.image.image_url,
               attachment_id: card.image.attachment_id
            }
         }
         if (getTemporaryBlockId(data.first_block) === faqId) {
            data.first_block.cards = [...data.first_block.cards, card];
         }
         data.blocks = data.blocks.map(m => {
            if (getTemporaryBlockId(m) === faqId) {
               m.cards = [...m.cards, card];
            }
            return m;
         });
         onChange(data);
      }
   }

   return (
      <nav >
         <div className="card-editor fadeInDown animated">
            {/* <i className="error-message">
               <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="exclamation-triangle" className="svg-inline--fa fa-exclamation-triangle fa-w-18 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path fill="currentColor"
                     d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z">
                  </path>
               </svg>
            </i> */}
            <div className={`card-item card-item-image ${!!getImage() && 'has-attachment'}`} onClick={handleClickUpload}>
               <div className="input-file">
                  <div className="input-file-drop" ariaDisabled="false">
                     <div className="flex-display" style={{ minHeight: 300 }}>
                        {!!getImage() &&
                           <img className="img-input-file width100" src={getImage()} />
                        }
                        <div className="text-center text-muted">
                           <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="image" className="svg-inline--fa fa-image fa-w-16 fa-2x m-center block-display mb5" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor"
                                 d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z">
                              </path>
                           </svg>
                           <span className="text-bigger">Hình ảnh</span>
                        </div>
                     </div>
                     <input
                        accept="image/jpg, image/jpeg, image/png, image/gif"
                        type="file"
                        onChange={onChangeFile}
                        autoComplete="off"
                        style={{ display: 'none' }}
                        ref={ref} />
                  </div>
               </div>
            </div>
            <Action
               onDelete={handleDelete}
               onCopy={handleCopy}
            />
         </div>
      </nav>
   )
}

export default Image;